import { useState, useEffect } from 'react';
import './PopupForm.css';
import popupImg from '../assets/popup.png';

const EMPTY  = { phone: '', email: '' };
const ERRORS = { phone: '', email: '' };

function isValidEmail(v) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());
}
function isValidPhone(v) {
  return /^[\d\s\+\-\(\)]{7,15}$/.test(v.trim());
}

export default function PopupForm() {
  const [visible,  setVisible]  = useState(false);
  const [form,     setForm]     = useState(EMPTY);
  const [errors,   setErrors]   = useState(ERRORS);
  const [status,   setStatus]   = useState('idle'); // idle | sending | success | error
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 7000);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    setVisible(false);
    setForm(EMPTY);
    setErrors(ERRORS);
    setStatus('idle');
    setErrorMsg('');
  };

  const validate = () => {
    const e = { phone: '', email: '' };
    if (!form.phone.trim())        e.phone = 'Phone number is required.';
    else if (!isValidPhone(form.phone)) e.phone = 'Enter a valid phone number.';
    if (!form.email.trim())        e.email = 'Email address is required.';
    else if (!isValidEmail(form.email)) e.email = 'Enter a valid email address.';
    setErrors(e);
    return !e.phone && !e.email;
  };

  const handleChange = (field) => (e) => {
    setForm(f => ({ ...f, [field]: e.target.value }));
    if (errors[field]) setErrors(err => ({ ...err, [field]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setStatus('sending');
    setErrorMsg('');

    const payload = new FormData();
    payload.append('phone', form.phone.trim());
    payload.append('email', form.email.trim());

    try {
      const res  = await fetch('/api/popup.php', { method: 'POST', body: payload });
      const data = await res.json();
      if (data.success) {
        setStatus('success');
      } else {
        setErrorMsg(data.message || 'Something went wrong. Please try again.');
        setStatus('error');
      }
    } catch {
      setErrorMsg('Network error. Please check your connection.');
      setStatus('error');
    }
  };

  if (!visible) return null;

  return (
    <div className="pf-overlay" onClick={close}>
      <div className="pf-modal" onClick={e => e.stopPropagation()}>
        <button className="pf-close" onClick={close} aria-label="Close popup">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>

        <img src={popupImg} alt="Offer" className="pf-image" />

        <div className="pf-body">
          {status === 'success' ? (
            <div className="pf-success">
              <div className="pf-success-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
                  stroke="#4f46e5" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
              </div>
              <p className="pf-success-text">We'll reach out to you shortly!</p>
            </div>
          ) : (
            <form className="pf-form" onSubmit={handleSubmit}>

              <div className="cs-field">
                <label className="cs-label" htmlFor="pf-phone">Phone / WhatsApp *</label>
                <input
                  id="pf-phone"
                  name="phone"
                  type="tel"
                  className={`cs-input${errors.phone ? ' cs-input--err' : ''}`}
                  placeholder="+91 98765 43210"
                  value={form.phone}
                  onChange={handleChange('phone')}
                />
                {errors.phone && <span className="pf-field-err">{errors.phone}</span>}
              </div>

              <div className="cs-field">
                <label className="cs-label" htmlFor="pf-email">Email Address *</label>
                <input
                  id="pf-email"
                  name="email"
                  type="email"
                  className={`cs-input${errors.email ? ' cs-input--err' : ''}`}
                  placeholder="you@example.com"
                  value={form.email}
                  onChange={handleChange('email')}
                />
                {errors.email && <span className="pf-field-err">{errors.email}</span>}
              </div>

              {status === 'error' && (
                <div className="cs-error">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="12" y1="8" x2="12" y2="12"/>
                    <line x1="12" y1="16" x2="12.01" y2="16"/>
                  </svg>
                  {errorMsg}
                </div>
              )}

              <button
                type="submit"
                className={`cs-submit pf-submit${status === 'sending' ? ' cs-submit--loading' : ''}`}
                disabled={status === 'sending'}
              >
                {status === 'sending' ? (
                  <><span className="cs-spinner" /> Sending…</>
                ) : (
                  <>
                    Get a Free Consultation
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="5" y1="12" x2="19" y2="12"/>
                      <polyline points="12 5 19 12 12 19"/>
                    </svg>
                  </>
                )}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
